import React from 'react';
import { useTranslation } from '@pascal/pascal-core';

export const AutoBetFooter = ({ handleAutoBetStart, isPlay, autoBetModel, allBetsModels }) => {
  const t = useTranslation();

  return (
    <div className='r-auto-bet-inner-footer' onClick={handleAutoBetStart}>
      <div className={`r-a-p-stop-inner ${allBetsModels.length ? '' : 'disabled'}`}>
        <div className={`r-a-p-stop-ins ${!autoBetModel || !isPlay ? '' : 'stop'}`}>
          <i className='icon-play' />
          <span>{!autoBetModel || !isPlay ? t('PLAY') : t('STOP')}</span>
        </div>
      </div>
    </div>
  );
};
